import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Footer from 'src/components/Footer.js';

const BlankLayout = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}
  >
    <Box sx={{ flex: 1 }}>
      {/* This is where your content goes */}
      <Outlet />
    </Box>
    <Box sx={{ marginTop: 'auto' }}>
      {/* The footer is pushed to the bottom */}
      {/*<Footer />*/}
    </Box>
  </Box>
);

export default BlankLayout;
